import { render, staticRenderFns } from "./GameView.vue?vue&type=template&id=3b3a5a34&scoped=true&"
import script from "./GameView.vue?vue&type=script&lang=ts&"
export * from "./GameView.vue?vue&type=script&lang=ts&"
import style0 from "./GameView.vue?vue&type=style&index=0&id=3b3a5a34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3a5a34",
  null
  
)

export default component.exports